import { Box, Button, CircularProgress, TextField } from "@mui/material";
import { green, red } from "@mui/material/colors";
import React, { useState } from "react";
import { post } from "../../utils/io";
import PasswordVerification from "../Auth/PasswordVerification";

export default function ChangePassword() {
  const [isPasswordError, setIsPasswordError] = useState(false);
  const [input, setInput] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [errMessage, setErrMessage] = useState("");
  const [isRequesting, setIsRequesting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const setNewPassword = (value) =>
    setInput((pre) => ({ ...pre, newPassword: value }));

  const setConfirmPassword = (value) =>
    setInput((pre) => ({ ...pre, confirmPassword: value }));

  const onCurrentPasswordChange = (e) => {
    setInput((pre) => ({ ...pre, currentPassword: e.target.value }));
  };

  const isButtonDisabled = () =>
    isRequesting ||
    !input.confirmPassword ||
    !input.currentPassword ||
    input.confirmPassword !== input.newPassword ||
    isPasswordError;

  const onSubmitForm = async () => {
    setIsRequesting(true);
    setErrMessage("");
    setSuccessMessage("");

    try {
      const payload = {
        current_password: input.currentPassword,
        new_password: input.newPassword,
      };
      const response = await post("/users/me/change_password", payload);
      setIsRequesting(false);
      if (response.status !== 204) {
        return setErrMessage(
          response.data.detail || "Failed to update password."
        );
      }
      setSuccessMessage("Password changed successfully.");
    } catch (error) {
      setErrMessage("Failed to update password.");
      setIsRequesting(false);
    }
    return null;
  };

  return (
    <Box sx={{ padding: "27px 56px" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: 350,
          margin: "auto",
        }}
      >
        <h1>Change Password</h1>
        <TextField
          size="small"
          variant="outlined"
          placeholder="Current Password"
          label="Current Password"
          onChange={onCurrentPasswordChange}
          value={input.currentPassword}
          type="password"
          sx={{
            marginBottom: "10px",
          }}
        />
        <PasswordVerification
          password={input.newPassword}
          setPassword={setNewPassword}
          confirmPassword={input.confirmPassword}
          setConfirmPassword={setConfirmPassword}
          passwordLabel="New Password"
          setError={setIsPasswordError}
        />
        {errMessage && (
          <Box
            sx={{
              color: red[500],
              fontStyle: "italic",
              textAlign: "center",
              marginTop: 0,
            }}
          >
            {errMessage}
          </Box>
        )}
        {successMessage && (
          <Box
            sx={{
              color: green[500],
              fontStyle: "italic",
              textAlign: "center",
              marginTop: 0,
            }}
          >
            {successMessage}
          </Box>
        )}
        <Button
          onClick={onSubmitForm}
          variant="contained"
          color="primary"
          sx={{ width: "100%" }}
          disabled={isButtonDisabled()}
        >
          {isRequesting && (
            <CircularProgress
              size={16}
              sx={{
                marginRight: "10px !important",
              }}
            />
          )}{" "}
          Submit
        </Button>
      </Box>
    </Box>
  );
}
